import * as Actions from '../../actions';

const initialState = { data: null };

const routeStatsReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_ROUTE_STATS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default routeStatsReducer;
